import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { deleteItem } from '../Api'

export default generateApiAction({
  baseType: Types.ITEMS.DELETE,
  api: deleteItem,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/items/DeleteAction.js